export const messages = {
    en: {
        matches: {
            nomatch: 'No matches',
            loadingmatches: 'Loading matches..',
            creatematch: 'Create new match',
            createfirstpart1: 'Create your first match',
            createfirstpart2: 'and you are ready to play 🙌',
        },
        newmatch: {
            fromscratch: 'Create new match',
            fromspond: 'Get match from Spond',
            description: 'You can create a new match in Playmatch, or get a match and players from Spond'
        },
        details: {
            startmatch: 'Start match',
            continuematch: 'Continue match',
            title: 'Description',
            titleplaceholder: 'Register e.g. the name of the opponent',
            delete: 'Delete match',
            reusePlayers: 'Do you want to use the players from the previous match?',
            reusePlayersButton: 'Add the same players',
            addPlayers: 'Or add players below 👇',
            noPlayersAdded: 'No players added, add them below 👇',
            add: 'Add player',
            playerName: 'Player name...',
            confirmDelete: 'Are you sure you want to delete the game?'
        },
        play: {
            restart: 'Restart match',
            confirmRestart: 'Are you sure you want to restart the match?',
            noPlayersAdded: 'No players added',
            configureTheTeam: 'Setup team',            
            infoSelectPlayers: 'Select which players will start the match. Use the buttons at the right side to put players on/off the field  👇',
            infoBeforeStart: 'The list is sorted by who has been on the field/bench the longest, the player who has been on/off the field the longest first ⏱',
            explainRowDetails: 'Player - since last substitution - total played',
            result: 'Result',
            noDescriptionSpecified: 'No description registered'
        },
        about: {
            whatIsPlaymatch: 'Playmatch helps you keep track of how much each player is on the field, and what the score is - so you can focus on the match 🙌',
            getStarted: 'Get started now!',
            howDoesItWork: 'How does Playmatch work?',
            howDoesItWorkPart1: 'Registrer the match you are going to play, and which players will be playing - and you are ready to play ⚽ ',
            howDoesItWorkPart2: 'Select the players to start the match, and when substitutions are made - Playmatch will keep track of how much each player has played (and how long he/she has been of the field). Goals are registered with the buttons at the bottom of the screen.',
            installHeader: 'Install Playmatch on your pohne',
            installDescription: 'For the best user experience you should save Playmatch to the home screen of your phone, so that it is easily available for the next match!',
            installAndroidPart1: 'Click',
            installAndroidPart2: 'at the top right of the screen, and select Add to homescreen.',
            installIphonePart1: 'Click the sharing icon',
            installIphonePart2: ', and select Add to homescreen.',
            dataStorageHeader: 'Where is your data stored?',
            dataStorageText: 'All the data is store on your phone. That is why you dont need to sign in or create an account to use Playmatch!',
            spondHeader: 'Do I have to use Spond?',
            spondText1: 'Of course not! but <a href="https://spond.com" target="_blank">Spond</a> is a greate service for managing you team, send invitations and keep track of who can participate. To avoid registering players multiple times, an event and the participating players can be imported from Spond til Playmatch.',
            spondText2: 'If you want to import your matches from Spond you have to log in with your Spond username/password. Playmatch does not does not keep track of any of your Spond data, except the matches you import to Playmatch.',
            contactHeader: 'Contact',
            contactText: `The app is developed by Kjetil Ek, coach for <a target="_blank" href="https://www.sknord.no/">SK Nord girls 2013</a>, and co-founder of <a href="https://restack.no">Restack Software</a>. If you have any questions or change proposals, feel free to send me an email at kjetil{'@'}restack.no 👋`,
            licenseHeader: 'License',
            licenseText: 'Playmatch is free to use 😀',
            thirdPartyLicenseHeader: 'Third party licenses',
            thirdPartyLicenseText: 'Playmatch is implemented using several open source components and services:',
            restackText: 'Playmatch is developed and hosted by Kjetil Ek, co-founder of <a href="https://restack.no" target="_blank">Restack Software</a>.'
        },
        spondLogin: {
            header: 'Log in',
            subHeader: 'Log in to Spond',
            description: 'To get matches/players from Spond you need to log in with your Spond user.',
            username: 'Username',
            usernamePlaceholder: 'Spond username',
            password: 'Password',
            passwordPlaceholder: 'Spond password',
            errorText: 'Error logging in',
            loginButton: 'Log in to Spond',
            resetPasswordText: 'Go to <a href="https://spond.com/forgot-password" target="_blank">spond.com</a> if you forgot your password'
        },
        spondGroups: {
            header: 'Spond groups',
            logOut: 'Log out of Spond',
            loading: 'Loading groups..',
            noGroupsFound: 'No groups found in Spond',
            noGroupsFoundDescription: 'Playmatch couldnt find any groups in Spond, are you sure you have access to one? 🤔',
            multipleGroups: 'You have access to multiple groups in Spond, select the group to get a match from 👇',
            select: 'Select'
        },
        spondMatches: {
            events: 'Events',
            logOut: 'Log out of Spond',
            changeGroup: 'Change group',
            loading: 'Loading matches..',
            noEvents: 'No events',
            noEventsDescription: 'No upcoming events found in Spond for the selected group',
            description: 'Select the match you are playing, and the match and players who have accepted the event will be imported to Playmatch',
            create: 'Create match',
            confirmCreate: 'Confirm that you want to create the match'
        },
        general: {
            about: 'About Playmatch',
            newmatch: 'New match',
            matchdetails: 'Match details',
            save: 'Save',
            match: 'Match'            
        }
    },
    no: {
        matches: {
            nomatch: 'Ingen kamper',
            loadingmatches: 'Henter kamper..',
            creatematch: 'Opprett kamp',
            createfirstpart1: 'Opprett din første kamp,',
            createfirstpart2: 'så er du i gang 🙌',            
        }, 
        newmatch: {
            fromscratch: 'Opprett en ny kamp',
            fromspond: 'Hent kamp fra Spond',
            description: 'Du kan opprette en ny kamp i Playmatch, eller hente kamp og spillere fra Spond'
        },
        details: {
            startmatch: 'Gjennomfør kamp',
            continuematch: 'Fortsett kampen',
            title: 'Beskrivelse',
            titleplaceholder: 'Legg inn f.eks. motstanderlaget',
            delete: 'Slett kamp',
            reusePlayers: 'Vil du bruke spillerne fra forrige kamp?',
            reusePlayersButton: 'Legg inn de samme spillerne',
            addPlayers: 'Eller legg til spillerne under 👇',
            noPlayersAdded: 'Ingen spillere lagt inn, legg de inn under 👇',
            add: 'Legg til',
            playerName: 'Spillerens navn...',
            confirmDelete: 'Er du sikker på at du vil slette kampen?'
        },
        play: {
            restart: 'Start kampen på ny',
            confirmRestart: 'Er du sikker på at du vil starte kampen på ny?',
            noPlayersAdded: 'Ingen spillere lagt til',
            configureTheTeam: 'Sett opp laget',
            infoSelectPlayers: 'Velg hvilke spiller som skal starte kampen. Bruk knappene til høyre for å ta spillere av/på banen  👇',
            infoBeforeStart: 'Listen sorteres etter hvem som har vært på banen/benken lengst, den som har vært lengst på/av banen viser først ⏱',
            explainRowDetails: 'Spiller - tid siden sist bytte - total spilletid',
            result: 'Resultat',
            noDescriptionSpecified: 'Ingen beskrivelse registrert'
        },
        about: {
            whatIsPlaymatch: 'Playmatch gir deg oversikten over hvor mye hver spiller er på banen, og hva stillingen er - så kan du konsentrere deg om kampen 🙌',
            getStarted: 'Kom i gang nå!',
            howDoesItWork: 'Hvordan fungerer Playmatch?',
            howDoesItWorkPart1: 'Registrer kampene som skal spilles, og hvilke spillere som skal være med - så er du klar for kamp ⚽ ',
            howDoesItWorkPart2: 'Velg spillerne som skal starte på banen, og registrer bytter fortløpende, så holder Playmatch kontroll på hvor mye hver spiller har spilt (og hatt pause). Mål registreres med knappene nederst på skjermen.',
            installHeader: 'Installer appen på telefonen',
            installDescription: 'For den beste opplevelsen bør du lagre appen på hjemskjermen på telefonen, så er den enkelt tilgjengelig der neste gang!',
            installAndroidPart1: 'Trykk på',
            installAndroidPart2: 'oppe til høyre , og velg Legg til på startsiden.',
            installIphonePart1: 'Trykk på delingsikonet',
            installIphonePart2: ', og velg Legg til hjemskjerm.',
            dataStorageHeader: 'Hvor lagres dataene dine?',
            dataStorageText: 'Alle dataene lagres kun på din telefon. Derfor trenger du heller ikke logge inn eller opprette en konto for å bruke Playmatch.',
            spondHeader: 'Må jeg bruke Spond?',
            spondText1: 'Neida! Men <a href="https://spond.com" target="_blank">Spond</a> er en bra løsning for å administrere lag, sende invitasjoner og holde styr på oppmøte. For å slippe å registrere spillere flere ganger er det mulig å hente kamper fra Spond til Playmatch.',
            spondText2: 'Hvis du vil hente kamper fra Spond må du logge inn med brukernavnet/passordet ditt hos Spond. Playmatch lagrer ingen av Sponddataene dine, bortsett fra kampene du setter opp i Playmatch.',
            contactHeader: 'Kontakt',
            contactText: `Appen et utviklet av Kjetil Ek, lagleder for <a href="https://www.sknord.no/">SK Nord J2013</a>, og partner i software-selskapet <a href="https://restack.no">Restack Software</a>. Hvis du lurer på noe eller har forslag til forbedringer kan du sende meg en mail på kjetil{'@'}restack.no 👋`,
            licenseHeader: 'Lisens',
            licenseText: 'Playmatch er gratis å bruke 😀',
            thirdPartyLicenseHeader: 'Tredjeparts lisenser',
            thirdPartyLicenseText: 'Playmatch er basert på flere andre open source komponenter:',
            restackText: 'Playmatch er utviklet og driftes av Kjetil Ek, partner i <a href="https://restack.no" target="_blank">Restack Software</a>.'

        },
        spondLogin: {
            header: 'Logg inn',
            subHeader: 'Logg inn på Spond',
            description: 'For å kunne hente kamper/spillere fra Spond må du logge inn med Spondbrukeren din.',
            username: 'Brukernavn',
            usernamePlaceholder: 'Brukernavn på Spond',
            password: 'Passord',
            passwordPlaceholder: 'Passord på Spond',
            errorText: 'Feil ved pålogging',
            loginButton: 'Logg inn på Spond',
            resetPasswordText: 'Gå til <a href="https://spond.com/forgot-password" target="_blank">spond.com</a> hvis du har glemt passordet ditt '
        },
        spondGroups: {
            header: 'Spondgrupper',
            logOut: 'Logg ut av Spond',
            changeGroup: 'Bytt gruppe',
            loading: 'Henter grupper..',
            noGroupsFound: 'Ingen grupper funnet i Spond',
            noGroupsFoundDescription: 'Fant ingen grupper i Spond, sikkert på at du har tilgang til en gruppe i Spond? 🤔',
            multipleGroups: 'Du har tilgang til flere grupper i Spond - velg Spondgruppa du skal hente kamper fra 👇',
            select: 'Velg'
        },
        spondMatches: {
            events: 'Arrangementer',
            logOut: 'Logg ut av Spond',
            loading: 'Henter kamper..',
            noEvents: 'Ingen arrangementer',
            noEventsDescription: 'Fant ingen arrangementer i Spond for gruppen',
            description: 'Velg kampen du skal spille, så blir kampen og spillere som har akseptert arrangementet satt opp i Playmatch',
            create: 'Opprett kamp',
            confirmCreate: 'Bekreft at du vil sette opp kampen'
        },
        general: {
            about: 'Om Playmatch',
            newmatch: 'Ny kamp',
            matchdetails: 'Kampinfo',
            save: 'Lagre',
            match: 'Kamp'
        }
    }
};